import React, { Component } from "react";
import { when } from 'mobx'
import { inject, observer } from "mobx-react";
import { Typeahead } from "react-typeahead";
import Enter from './Enter'
import Button from '../Button'

@inject("CheckInStore")
@inject("RiderStore")
@observer
class SelectRider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: null,
      displayOption: null
    };
  }
  

  componentDidMount() {
    const {RiderStore} = this.props
    when(
      () => RiderStore.allRiders.length > 0,
      () => {
        let options = RiderStore.allRiders.map(option => {
          option.fullName = option.name;
          return option;
        });
        this.setState({
          options: options,
          displayOption: option => option.fullName
        });
      }
    );
  }

  render() {
    const {CheckInStore, base, handleNext} = this.props;
    const disabled = true;
  
    return (
      <div className="section text--left">
        <div className={`${base}__section-area`}>
          <p className="fs--large">Rider check in</p>
        </div>
        <div
          className={`${
            base
          }__section-area display--flex justify--center rider-check-in`}
        >
          <div className="check-in-area display--flex">
            <Typeahead
              id="rider-search"
              ref={(input) => { this.nameInput = input; }} 
              options={this.state.options}
              filterOption="fullName"
              displayOption={this.state.displayOption}
              maxVisible={5}
              className="typeahead"
              placeholder="Rider name"
              onOptionSelected={CheckInStore.handleSelect}
              defaultValue={CheckInStore.name}
            />
            <div className="button-container" style={{ marginLeft: "15px" }}>
              <Button 
                id={'select-rider-next'}
                onClick={handleNext}
                disabled={CheckInStore.isDisabled()}
                content={'Next'}
              />
              <Enter />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SelectRider;



// WEBPACK FOOTER //
// ./src/components/checkIn/SelectRider.js